import $ from 'jquery'

import colors from '../../../../lib/colors'

import { button, textarea } from '../../../../component/component'

export function getTableDiv(value){

  var div =
    $('<div>')
    .text(value)
    .css({
      padding: '8px'
    })

  return div

}

export function filterMatch(column,filter){

  if(!column.value){
    if(filter === 'null'){
      return true
    } else {
      return false
    }
  }

  if (column.value && filter == '*'){
    return true
  }

  var f = filter.toLowerCase()
  var c = column.value.toLowerCase()

  if(_.includes(c,f)){
    return true
  } else {
    return false
  }

}

export function getFormField(o,p,field){

  var format = function(value){
    return value
  }

  var parse = function(value){
    value = value.trim()
    return value
  }

  var validate = function(value){
    if(
      value ||
      field.optional
    ){
      p.change(field,value,true)
      labelDiv.setColor(colors.white)
      return true
    } else {
      p.change(field,value,false)
      labelDiv.setColor(colors.red.s_500)
      return false
    }
  }

  var labelDiv =
    button(field.id,null,true)
    .css({
      display: 'block',
    })

  var disabled = field.edit ? false : true

  var inputDiv =
    textarea(disabled)
    .attr({
      multiline: true,
      rows: 5,
    })
    .val(
      format(field.value)
    )
    .on('input',function(){
      var value = inputDiv.val()
      validate(parse(value))
      console.log(parse(value))
    })

  var div =
    $('<div>')
    .css({
      position: 'relative'
    })
    .append(
      labelDiv,
      inputDiv,
    )

  requestAnimationFrame(function(){
    var value = inputDiv.val()
    validate(parse(value))
  })

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/type/textLong/textLong.js